export default __webpack_public_path__ + "static/media/eye.71008c40.svg";